
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForwardFast as ObiForwardFastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-forward-fast.js';
 
 
 

 
 export const ObiForwardFast = createComponent({
   react: React,
   tagName: 'obi-forward-fast',
   elementClass: ObiForwardFastElement,
   events: {
     
   }
  });
 
 